export default __webpack_public_path__ + "static/media/guides.1b4838b0.svg";